/**
@ngdoc directive
@name xmsAutocomplete

@description
Autocomplete field.<br/>
<br />
Unfortunately it's still ain't perfect but this is the best what we can have with Angular UI 0.14.0 (IE8!)<br />
Issues / after upgrade TODO:<br />
- validation shouldn't come up if validation dropdown is open<br />
- "No results" message should disappear once the field is empty etc.<br />

@param {url} autocomplete-url will be used as a GET call ie. "/address/lookup?"
@param {string} autocomplete-url-param will be used as a GET call parameter ie. "term" for /address/lookup?term=autocomplete_user_input
@param {expression=} autocomplete-expression (optional, advanced) http://stackoverflow.com/questions/19657602/what-is-the-comprehension-expression-in-angularjs<br />
                        see angular select and ng-options documentation<br />
                        Supported expressions are: label for value in sourceArray, select as label for value in sourceArray<br />
                        "response as response.value for response in getUrl($viewValue)" by default<br />
@param {string} autocomplete-label-property (optional, advanced, "value" by default) value for  "response as response.value for response in getUrl($viewValue)" (default)<br />
                        autocomplete-comprehension overrides this parameter

@param {boolean=} editable editable="true" is used to allow values that do not match autocomplete list, empty editable attribute is required for validation message

@usage
Please see testValidation
*/

(function() {
  'use strict';

var xmsAutocomplete = function ($http, $compile, $sce) {
    return {
        scope: true, // child scope !
        restrict: "A",
        replace: true,
        priority: -10,
        template: function(tElement, tAttrs){

            // set default comprehension expression label value
            var property = tAttrs.autocompleteLabelProperty || "value";
            var comprehensionExpression = tAttrs.autocompleteExpression || "resp as resp."+property+" for resp in getUrl($viewValue)";
            // tAttrs.ngModel = '$parent.'+tAttrs.ngModel;
            // tAttrs.ngInit = '$parent.'+tAttrs.ngInit;
            return [
                '<input autocomplete="off" type="',tAttrs.type,'"', // IE8 workaround - IE8 will not allow type attribute change or merge. See https://github.com/angular/angular.js/issues/4029
                ' uib-typeahead="',comprehensionExpression,'"',
                ' typeahead-loading="loadingLocations"',
                ' typeahead-no-results="noResults"',
                ' typeahead-editable="',(tAttrs.editable=='true')?'true':'false','"',
                ' typeahead-focus-first="false"',
                ' validation-messages-class="spinner-input-box"',
                angular.isDefined(tAttrs.name) ? ' aria-describedby="' + tAttrs.name + '.aria"': '',
                // 'typeahead-is-open="dropdownOpen"', // if only we could upgrade above 0.14.0 (IE8!)
            '>'].join("");
        },
        controller: function(){
        },
        link: {
            pre: function(scope, element, attrs) {
                element.wrap('<div class="spinner-input-box__wrapper autocomplete-box__wrapper"></div>');

                if(angular.isDefined(attrs.name)){
                    // accessibility describedby
                    element.before('<p id="'+attrs.name+'.aria" class="sr-only">Search as you type</p>');
                }
                const magGlass= '<span class="glyphicon glyphicon-search" aria-hidden="true"></span>'
                const loadingSpinner = '<i ng-if="loadingLocations" class="autocomplete-spinner loading-spinner" role="alert" aria-live="assertive"><span class="sr-only">Loading...</span></i>'
                element.before($compile('<div class="spinner-input-box autocomplete-box"> ' + magGlass + loadingSpinner + '</div>')(scope))

                // "no results" message - we want to place it always after the validation msg
                if(attrs.editable != 'true' ){
                    var noResultsMsg = "No results found - please try to amend your search.";
                    var noResultsMsgElement = '<small ng-if="noResults && !connectionError" class="text-muted" role="alert" aria-live="assertive">'+noResultsMsg+'</small>';
                    element.parent().after( $compile( noResultsMsgElement )(scope));
                }
                // add connection error
                element.parent().after( $compile('<small ng-if="connectionError" class="text-danger" role="alert" aria-live="assertive">{{connectionError}}</small>')(scope) );
            },

            post: function(scope, element, attrs) {

        		scope.getUrl = function(val) {
                    var baseUrl = (attrs.autocompleteUrl.indexOf(WEBAPP_PATH) == -1)?WEBAPP_PATH:'';
    			    return $http.get( baseUrl + attrs.autocompleteUrl + '&' + attrs.autocompleteUrlParam + '=' + encodeURIComponent(val) , {
    			    	/*params: {
    			        	term: val
    			      	}*/
    			    }).then(function(response){
                        delete scope.connectionError;
    			    	return response.data.map(
    			    		function(returnValue){
                                returnValue.value = $sce.trustAsHtml(returnValue.value).toString();
    			        		return returnValue;
    			    		}
    		    		);
    			    }, function errorCallback(response) {
                        // called asynchronously if an error occurs
                        // or server returns response with an error status.
                        console.log(response);
                        scope.connectionError = response.statusText==='' ? response.data.statusText : "Connection error " + response.status +': ' + response.statusText + '.';
                    });
    			}
            }
        }

    };
}

xmsAutocomplete.$inject = ['$http', '$compile', '$sce'];
angular.module('app').directive('xmsAutocomplete', xmsAutocomplete);

}());



